import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, DatePicker, Button, message, Card, Typography } from 'antd';
import { SafetyCertificateOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { ref, push, set, get } from 'firebase/database';
import { db, realtimeDb } from '../firebaseConfig';
import dayjs from 'dayjs';

const { Title } = Typography;

const FakturaKsef = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [driverId, setDriverId] = useState(null);
  const [success, setSuccess] = useState(false);
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const loadDriverId = async () => {
      if (!currentUser) return;
      try {
        const snap = await getDoc(doc(db, 'users', currentUser.uid));
        if (snap.exists()) {
          setDriverId(snap.data().driverId);
        }
      } catch (e) {
        console.error('Error loading driverId:', e);
      }
    };
    loadDriverId();
  }, [currentUser]);

  const handleSubmit = async (values) => {
    if (!driverId) {
      message.error('Nie znaleziono ID kierowcy');
      return;
    }

    setLoading(true);
    try {
      const invoiceData = {
        timestamp: Date.now(),
        invoiceDate: values.date.format('YYYY-MM-DD'),
        grossAmount: values.amount,
        vehicleNumber: values.vehicleNumber || '',
        status: 'W trakcie weryfikacji',
        addedBy: 'driver',
        source: 'ksef_driver',
        type: 'KSeF',
        uploadDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      };

      const invoicesRef = ref(realtimeDb, `drivers/${driverId}/invoices`);
      const newRef = push(invoicesRef);
      await set(newRef, invoiceData);

      message.success('Faktura KSeF dodana pomyślnie');
      setSuccess(true);
      form.resetFields();

      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error) {
      console.error('Error adding KSeF invoice:', error);
      message.error('Błąd: ' + error.message);
    }
    setLoading(false);
  };

  if (success) {
    return (
      <div style={{ padding: 16, textAlign: 'center' }}>
        <Card>
          <CheckCircleOutlined style={{ fontSize: 64, color: '#52c41a', marginBottom: 16 }} />
          <Title level={4}>Faktura dodana!</Title>
          <p>Przekierowanie na stronę główną...</p>
        </Card>
      </div>
    );
  }

  return (
    <div style={{ padding: 16 }}>
      <Card
        title={
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <SafetyCertificateOutlined style={{ color: '#1890ff' }} />
            <span>Faktura wystawiona w KSeF</span>
          </div>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="date"
            label="Data tankowania / faktury"
            rules={[{ required: true, message: 'Wybierz datę' }]}
          >
            <DatePicker
              style={{ width: '100%' }}
              format="DD.MM.YYYY"
              placeholder="Wybierz datę"
            />
          </Form.Item>

          <Form.Item
            name="amount"
            label="Kwota (brutto)"
            rules={[{ required: true, message: 'Wpisz kwotę' }]}
          >
            <InputNumber
              style={{ width: '100%' }}
              min={0}
              step={0.01}
              precision={2}
              placeholder="0.00"
              addonAfter="zł"
            />
          </Form.Item>

          <Form.Item
            name="vehicleNumber"
            label="Nr rejestracyjny"
            rules={[{ required: true, message: 'Wpisz numer rejestracyjny' }]}
          >
            <Input placeholder="np. WA 12345" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
              icon={<SafetyCertificateOutlined />}
            >
              Dodaj fakturę KSeF
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default FakturaKsef;
